export const BREAKPOINTS = {
  DEFAULT: 'default',
  MOBILE: 'mobile'
};
export const STATIC_BREAKPOINT_CONFIG = {
  breakpoints: [{
    name: 'default',
    order: 0
  }, {
    mediaQuery: '@media (max-width: 639px)',
    name: 'mobile',
    previewWidth: {
      units: 'px',
      value: 639
    },
    order: 1
  }]
};